import { Component, ElementRef, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AsyncValidatorFn, FormControl, FormGroup, Validators } from '@angular/forms';
import { of } from 'rxjs';
import { debounceTime, distinctUntilChanged, first, map, switchMap, catchError } from 'rxjs/operators';
import { Environment, Solution } from 'src/app/model/SolutionInfo';
import { SolutionService } from 'src/app/service/solution.service';
import { emptyValidator } from 'src/app/validator/empty-form-validator';

export enum FormMode {
  ADD,
  EDIT
}

export enum FormObjectType{
  SOLUTION,
  ENVIRONMENT
}

@Component({
    selector: 'app-solution-form',
    templateUrl: './solution-form.component.html',
    styleUrls: ['./solution-form.component.css'],
    standalone: false
})
export class SolutionFormComponent implements OnInit {

  @Input() height: string = 'calc(100vh - 150px)';
  @Input() mode: FormMode;
  @Input() type: FormObjectType;
  @Input() solution: Solution;
  @Input() environment: Environment;
  @Input() showFormSubmitCtrls: boolean = true;
  @Output() formEvent = new EventEmitter<FormGroup>();
  @Output() errorEvent = new EventEmitter<boolean>();
  
  FormMode = FormMode;
  FormObjectType = FormObjectType;

  objectForm: FormGroup;

  constructor(private solutionSrv: SolutionService,
              private eleRef: ElementRef) { }

  get nameCtrl() { return this.objectForm.get('nameCtrl'); }
  get descriptionCtrl() { return this.objectForm.get('descriptionCtrl'); }

  ngOnInit(): void {
    this.objectForm = new FormGroup({
      nameCtrl: new FormControl('', [
        Validators.required, emptyValidator()
      ], [this.checkIfNameIsTaken()]),
      descriptionCtrl: new FormControl('', [
      ])
    });

    if(this.mode == FormMode.EDIT){
      if(this.type == FormObjectType.SOLUTION){
        this.nameCtrl.setValue(this.solution.name);
        this.descriptionCtrl.setValue(this.solution.description);
      } else {
        this.nameCtrl.setValue(this.environment.name);
        this.descriptionCtrl.setValue(this.environment.description);
      }
    }

    this.objectForm.valueChanges.subscribe(val => {
      this.formEvent.emit(this.objectForm);
    });

    this.formEvent.emit(this.objectForm);
  }

  checkIfNameIsTaken(): AsyncValidatorFn {
    if(this.type == FormObjectType.SOLUTION){
      return this.checkIfSolNameIsAlreadyTaken();
    }else{
      return this.checkIfEnvNameIsAlreadyTaken();
    }
  }

  checkIfSolNameIsAlreadyTaken(): AsyncValidatorFn {
    return control => control.valueChanges.pipe(
      debounceTime(500),
      distinctUntilChanged(),
      switchMap(value => this.solutionSrv.validateSolutionName(value.trim())),
      map((result) => (result.body ? null : { exists: true })),
      first(),
      catchError(resp => {
        this.errorEvent.emit(true);
        return of(resp)
      }),
    );
  }

  checkIfEnvNameIsAlreadyTaken(): AsyncValidatorFn {
    return control => control.valueChanges.pipe(
      debounceTime(500),
      distinctUntilChanged(),
      switchMap(value => this.solutionSrv.validateEnvironmentName(this.solution.name, value.trim())),
      map((result) => (result.body ? null : { exists: true })),
      first(),
      catchError(resp => {
        this.errorEvent.emit(true);
        return of(resp)
      }),
    )
  }
}
